import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import Base from '@cx/couturier/Base'
import { Col, Container, Row } from '@cx/couturier/Grid'
import styled from 'styled-components'
import _map from 'lodash/map'
import Header from './header'
import DidYouKnow from './did-you-know'
import Articles from './articles'
import LogBackInBtn from './log-back-in-btn'

const HiddenIframe = styled.iframe`
  display: none;
`
function LogoutFrames (logoutUrls) {
  const randomizeUrl = `?${Math.floor(Math.random() * 100000000)}${Math.floor(Math.random() * 100000000)}`
  const urls = _map(logoutUrls.urls, (url) => url + randomizeUrl)

  return (
    <div className='iframe-container'>
      {urls.map((url) => (
        <HiddenIframe key={url} src={`${url}`} title={url} />
      ))}
      <HiddenIframe key={logoutUrls.nmisLogoutUrl} src={`${logoutUrls.nmisLogoutUrl}`} title={logoutUrls.nmisLogoutUrl} />
    </div>
  )
}

function App ({ articles, urls }) {
  return (
    <div className='padding row'>
      <Base luna>
        <Container>
          <Row align='right'>
            <Col>
              <LogBackInBtn passedClass='desktop-only' />
            </Col>
          </Row>
          <Header />
          {!articles.length ? (
            <Row className='no-articles'>
              <Col small={5}>
                <DidYouKnow />
              </Col>
            </Row>
          ) : (
            <Row>
              <Col large={3} small={12}>
                <DidYouKnow />
              </Col>
              <Col large={9} small={12}>
                <Articles />
              </Col>
            </Row>
          )}
        </Container>
      </Base>
      <LogoutFrames {...urls} />
    </div>
  )
}

const mapStateToProps = (state) => ({
  articles: state.articles,
  urls: state.logoutUrls
})

App.propTypes = {
  articles: PropTypes.array.isRequired,
  urls: PropTypes.shape({
    urls: PropTypes.arrayOf(PropTypes.string),
    nmisLogoutUrl: PropTypes.string
  }).isRequired
}

export default connect(mapStateToProps)(App)
